export default "__VITE_ASSET__DS5kuMTa__"